import LayerProxy, {Options as LayerOptions} from "./LayerProxy";

export default class AutoLayerManager {
    private queue: LayerProxy[] = [];
    private interfaceBlocked = true;
    private activeLayer: LayerProxy;

    blockInterface() {
        this.interfaceBlocked = true;
    }

    unblockInterface() {
        this.interfaceBlocked = false;
    }

    unblockAndProcessQueue() {
        this.unblockInterface();
        this.processQueue();
    }

    enqueue(l: LayerProxy|LayerOptions) {
        let lp: LayerProxy;
        if (l instanceof LayerProxy) {
            lp = l;
        } else {
            lp = new LayerProxy(<LayerOptions>l);
        }
        this.queue.push(lp);
        this.queue.sort(function(a, b) {
            return a.getPriority() - b.getPriority();
        });

        this.processQueue();
    }

    dequeue() {
        return this.queue.pop();
    }

    processQueue() {
        while (!this.isInterfaceBlocked() && this.queue.length > 0) {
            this.activeLayer = this.dequeue();
            if (this.activeLayer.getBlocking()) {
                this.blockInterface();
            }
            this.activeLayer.runCallback();
        }
    }

    isInterfaceBlocked() {
        return this.interfaceBlocked === true;
    }

    getInterfaceBlocked() {
        return this.interfaceBlocked;
    }

    setInterfaceBlocked(stat: boolean) {
        this.interfaceBlocked = stat;
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/autolayermanager/AutoLayerManager.ts
 **/